// AUTO-GENERATED by scripts/generate-motions.mjs — do not edit by hand.
// Re-run `npm run generate:motions` after changing the motion definitions.

export interface BuiltinGesture {
  name: string;
  label: string;
  url: string;
  /** Seconds. */
  duration: number;
  /** Full-body gestures also drive the legs (e.g. kneeling), so they
   *  override walking; upper-body gestures layer over it. */
  fullBody: boolean;
  /** Hold gestures stay on their final pose until released, instead of
   *  playing once and returning to the body's previous motion. */
  hold: boolean;
  /** Hidden gestures aren't offered in the menu or on the number keys —
   *  something else in the app triggers them (sitting on a chair). */
  hidden: boolean;
  /**
   * How the app should settle this pose onto the world at runtime.
   *
   * A clip can only carry one hip height, but every avatar has different
   * leg proportions, so a baked height that grounds one body leaves another
   * hovering or sunk. "floor" drops the avatar until whatever is lowest
   * (shins, feet) rests on the ground; "seat" lifts the hips to the height
   * of the seat they're sitting on; "body" is "floor" for any part of the
   * body, for lying down. See AvatarAnimator.
   */
  ground: "none" | "floor" | "seat" | "body";
  /** Loops while held (a dance), instead of stopping on its last frame. */
  loop: boolean;
}

// The ?v= is a content hash: regenerating a clip changes its URL, so a
// browser that cached the old bytes fetches the new ones instead of quietly
// keeping the old motion.
export const LOCOMOTION_CLIPS = {
  idle: "/animations/idle.vrma?v=cbf44553",
  walk: "/animations/walk.vrma?v=b30c3f95",
  run: "/animations/run.vrma?v=9029a1cf",
  jump: "/animations/jump.vrma?v=faaadf4b",
} as const;

export const BUILTIN_GESTURES: BuiltinGesture[] = [
  {
    "name": "wave",
    "label": "Wave",
    "url": "/gestures/builtin/wave.vrma?v=8fd9a5e9",
    "duration": 2.88,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "bow",
    "label": "Bow (ojigi)",
    "url": "/gestures/builtin/bow.vrma?v=8b815cac",
    "duration": 3.12,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "crouch",
    "label": "Crouch (hold)",
    "url": "/gestures/builtin/crouch.vrma?v=a4849f24",
    "duration": 0.66,
    "fullBody": false,
    "hold": true,
    "hidden": true,
    "ground": "none",
    "loop": false
  },
  {
    "name": "seiza",
    "label": "Seiza (hold)",
    "url": "/gestures/builtin/seiza.vrma?v=3fe699f2",
    "duration": 1.8,
    "fullBody": true,
    "hold": true,
    "hidden": false,
    "ground": "floor",
    "loop": false
  },
  {
    "name": "nod",
    "label": "Nod",
    "url": "/gestures/builtin/nod.vrma?v=ed9fa74d",
    "duration": 1.92,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "clap",
    "label": "Clap",
    "url": "/gestures/builtin/clap.vrma?v=4869d1d8",
    "duration": 2.64,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "cheer",
    "label": "Cheer",
    "url": "/gestures/builtin/cheer.vrma?v=09581078",
    "duration": 2.64,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "shrug",
    "label": "Shrug",
    "url": "/gestures/builtin/shrug.vrma?v=43a28dac",
    "duration": 2.28,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "point",
    "label": "Point",
    "url": "/gestures/builtin/point.vrma?v=b9803b3e",
    "duration": 2.4,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "gassho",
    "label": "Gasshō (thanks)",
    "url": "/gestures/builtin/gassho.vrma?v=cb635107",
    "duration": 4.32,
    "fullBody": false,
    "hold": false,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "raisehand",
    "label": "Raise hand (hold)",
    "url": "/gestures/builtin/raisehand.vrma?v=4307e73c",
    "duration": 1.08,
    "fullBody": false,
    "hold": true,
    "hidden": false,
    "ground": "none",
    "loop": false
  },
  {
    "name": "sit",
    "label": "Sit",
    "url": "/gestures/builtin/sit.vrma?v=4855efff",
    "duration": 1.14,
    "fullBody": true,
    "hold": true,
    "hidden": true,
    "ground": "seat",
    "loop": false
  },
  {
    "name": "lie",
    "label": "Lie down",
    "url": "/gestures/builtin/lie.vrma?v=56610941",
    "duration": 2.04,
    "fullBody": true,
    "hold": true,
    "hidden": true,
    "ground": "body",
    "loop": false
  },
  {
    "name": "dance",
    "label": "Dance",
    "url": "/gestures/builtin/dance.vrma?v=c1a2861b",
    "duration": 2.88,
    "fullBody": true,
    "hold": true,
    "hidden": false,
    "ground": "none",
    "loop": true
  },
  {
    "name": "slowdancelead",
    "label": "Slow dance (lead)",
    "url": "/gestures/builtin/slowdancelead.vrma?v=92d40db8",
    "duration": 4.32,
    "fullBody": true,
    "hold": true,
    "hidden": true,
    "ground": "none",
    "loop": true
  },
  {
    "name": "slowdancefollow",
    "label": "Slow dance (follow)",
    "url": "/gestures/builtin/slowdancefollow.vrma?v=dd64c141",
    "duration": 4.32,
    "fullBody": true,
    "hold": true,
    "hidden": true,
    "ground": "none",
    "loop": true
  },
  {
    "name": "fistbump",
    "label": "Fist bump",
    "url": "/gestures/builtin/fistbump.vrma?v=49434645",
    "duration": 2.04,
    "fullBody": false,
    "hold": false,
    "hidden": true,
    "ground": "none",
    "loop": false
  },
  {
    "name": "dap",
    "label": "Dap",
    "url": "/gestures/builtin/dap.vrma?v=8cb32a80",
    "duration": 2.4,
    "fullBody": false,
    "hold": false,
    "hidden": true,
    "ground": "none",
    "loop": false
  },
  {
    "name": "handshake",
    "label": "Handshake",
    "url": "/gestures/builtin/handshake.vrma?v=6f1ade3a",
    "duration": 2.88,
    "fullBody": false,
    "hold": false,
    "hidden": true,
    "ground": "none",
    "loop": false
  },
  {
    "name": "highfive",
    "label": "High five",
    "url": "/gestures/builtin/highfive.vrma?v=d065239f",
    "duration": 1.68,
    "fullBody": false,
    "hold": false,
    "hidden": true,
    "ground": "none",
    "loop": false
  },
  {
    "name": "hug",
    "label": "Hug",
    "url": "/gestures/builtin/hug.vrma?v=0c49af83",
    "duration": 3.48,
    "fullBody": false,
    "hold": false,
    "hidden": true,
    "ground": "none",
    "loop": false
  }
];
